export type CallbackFunction<CallbackResultType> = (result: CallbackResultType) => void;

export class CallbackCache<CallbackResultType, CallbackType extends CallbackFunction<CallbackResultType>> {
  private callback: CallbackType | null;

  constructor() {
    this.callback = null;
  }

  setCallback(callback: CallbackType): void {
    this.callback = callback;
  }

  invoke(result: CallbackResultType): void {
    if (this.callback) {
      this.callback(result);
    }

    this.callback = null;
  }
}
